module.exports = __webpack_public_path__ + "media/a6.4bc13c58.wav";